export const getTmbCards = {
    data: {
        catalogues: [
            {
                id: "barcelona-bus-turist",
                name: "Bus Turístico Barcelona",
                description: "Descubre los lugares más emblemáticos de Barcelona recorriendo sus calles con el autobús turístico oficial.",
                image: "https://renfe.demo.hafas.de/spf/api/v1/providers/tmb/images/fq5wT6COXXL4dV5138AZWAXvdO1JSWmEdxlexxxzWXGBCJ23wzqlS0uLBDxpqIGi"
            },
            {
                id: "holabarcelona-travel-card",
                name: "Hola Barcelona Travel Card",
                description: "Disfruta de viajes ilimitados en el transporte público de Barcelona durante 2 días (48h), 3 días (72h), 4 días (96h) o 5 días (120h).",
                image: "https://renfe.demo.hafas.de/spf/api/v1/providers/tmb/images/0FtJF0A35Vr8RSd7v1RFHOiY3OXPCIHsUXbsOUgOn0YrQwG51LFNSm8ulvLPDY1w"
            },
            {
                id: "montjuic-cable-car",
                name: "Teleférico de Montjuïc",
                description: "Sube al Teleférico de Montjuïc y contempla la panorámica de Barcelona desde un lugar privilegiado.",
                image: "https://renfe.demo.hafas.de/spf/api/v1/providers/tmb/images/BHZhlaGJJAToY5xHJZib8kGRNzJlUCDxLrcv43MgUDeueOE4Ox833pgFQ3qbrz1p"
            },
            {
                id: "night-tour",
                name: "Barcelona Night Tour Bus",
                description: "Sube Barcelona Night Tour Bus y contempla la panorámica de Barcelona desde un lugar privilegiado.",
                image: "https://www.tmb.cat/documents/20182/388729/barcelona-christmas-tour-928x320jpg.jpg/9a56d4e8-1da2-437d-89c6-78aa03cd9a8b?t=1682329102000"
            }
        ], 
        privacyPolicy: "https://www.tmb.cat/en/personal-data-protection-policy#content-title-transport-users",
        termsAndConditions: "https://www.holabarcelona.com/es/condiciones-generales"    
    }
}